import { inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class MobileDrawerService {
  private _isOpen = new BehaviorSubject<boolean>(false)
  public isOpen$ = this._isOpen.asObservable()
  private _rendererFactory = inject(RendererFactory2)
  private _renderer: Renderer2
  // Escape listener
  private removeEscapeListener: () => void

  constructor() {
    // Create renderer -> this is used to add and remove classes from the body and didn't access the body directly because it's not a good practice
    this._renderer = this._rendererFactory.createRenderer(null, null)
  }

  open(): void {
    this._isOpen.next(true)
    // Prevent body scroll when drawer is open
    this._renderer.addClass(document.body, 'tw-overflow-hidden')
  }

  close(): void {
    this._isOpen.next(false)
    // Restore body scroll when drawer is closed
    this._renderer.removeClass(document.body, 'tw-overflow-hidden')
  }

  toggle(): void {
    if (this._isOpen.value) {
      this.close()
    } else {
      this.open()
    }
  }

  get isOpen(): boolean {
    return this._isOpen.value
  }

  // Close drawer when clicking outside or pressing escape
  initializeGlobalListeners(): void {
    // Close on escape key
    if (this.removeEscapeListener) return // avoid duplicates

    this.removeEscapeListener = this._renderer.listen('document', 'keydown', (event: KeyboardEvent) => {
      if (event.key === 'Escape' && this.isOpen) {
        this.close()
      }
    })
  }

  // Destroy global listeners
  destroyGlobalListeners(): void {
    if (this.removeEscapeListener) {
      this.removeEscapeListener()
      this.removeEscapeListener = undefined
    }
  }
}
